import React, { useState, useEffect } from 'react'
import {
  Card,
  CardBody,
  Row,
  Col,
  Container,
  Modal,
  ModalHeader,
  CardHeader,
  CardTitle
} from "reactstrap"
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import paginationFactory from 'react-bootstrap-table2-paginator'
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import useToggle from "../../../lib/useToggle"
import Loading from '../../../lib/loading'
import FormConvenio from './formConvenio'

const colunas_convenios = [
  {
    dataField: 'convenio_id',
    text: 'Cód',
    align: 'left',
  },
  {
    dataField: 'convenio',
    text: 'Convênio',
    align: 'center',
    headerStyle: { cursor: 'default' }
  },
  {
    dataField: 'conv_cnpj',
    text: 'CNPJ',
    align: 'center',
    headerStyle: { cursor: 'default' }
  },
  {
    dataField: 'conv_uf',
    text: 'UF',
    align: 'center',
    headerStyle: { cursor: 'default' }
  }
]

function FechaConvenio() {

  const { SearchBar }                       = Search
  const [loading, setLoading]               = useState(true)
  const [listaConvenios, setListaConvenios] = useState([])
  const [modal, setModal]                   = useToggle(false)
  const [convenioId ,setConvenioId]         = useState('')
  const [nomeConvenio ,setNomeConvenio]     = useState('')
  const [convCnpj ,setConvCnpj]             = useState('')

  const lista_convenio = () => {
    let lista = []
    const url = rotas.convenios
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        // console.log(ret)
        if (ret.success==='S' && ret.lista && ret.lista !== ''){
          lista = ret.lista
          setListaConvenios(lista)
        }
        setLoading(false)
      })
      return (true)
    }catch(err){
      console.log(err)
    }
  }

  useEffect(() => {
      lista_convenio()
  }, [])

  useEffect(() => {
    if(modal===false){
      lista_convenio()
    }
  }, [modal])

  const abreModal = (convenio_id, nome_convenio, conv_cnpj) => {
    setConvenioId(convenio_id)
    setNomeConvenio(nome_convenio)
    setConvCnpj(conv_cnpj)
    setModal()
  }

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  } else {
    return (
      <div className="content">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <Row>
                    <Col>
                      <CardTitle>Fechamento de Convêncio</CardTitle>
                    </Col>
                  </Row>
                </CardHeader>

                <CardBody>

                  <div>
                  <ToolkitProvider
                    search
                    outline
                    keyField  = "convenio_id"
                    data      = {listaConvenios}
                    columns   = {colunas_convenios}
                  >
                    {
                      
                      props => (
                        <div>
                          {/* <Container> */}
                            <Row>
                              {/* <Col md="6">
                              </Col> */}

                              <Col md="12">
                                <SearchBar
                                  placeholder = "Buscar Convênio..."
                                  style       = {{ padding: '5px' }}
                                  {...props.searchProps}
                                />
                              </Col>
                            </Row>
                          {/* </Container> */}

                          <hr/>

                          <BootstrapTable
                            striped
                            keyField          = 'convenio_id'
                            data              = {listaConvenios}
                            columns           = {colunas_convenios}
                            noDataIndication  = "Nenhum registro encontrado"
                            pagination        = {paginationFactory({
                                                  sizePerPage: 10,
                                                  hideSizePerPage: true,
                                                  hidePageListOnlyOnePage: true,
                                                  showTotal: false,
                                                })}
                            rowStyle          = {{ cursor: "pointer" }}
                            rowEvents         = {{
                                                  onDoubleClick: (e, row, rowIndex) => {
                                                    abreModal(row.convenio_id, row.convenio, row.conv_cnpj)
                                                  }
                            }}
                            {...props.baseProps}
                          />
                        </div>
                      )
                    }
                  </ToolkitProvider>
                  </div>

                </CardBody>
              </Card>

              <Modal
                size    = 'xl'
                isOpen  = {modal}
              >
                <ModalHeader>Fechamento de Convênio</ModalHeader>
                <FormConvenio
                  fechaModal  = {setModal}
                  convenio_id = {convenioId}
                  convenio    = {nomeConvenio}
                  conv_cnpj   = {convCnpj}
                  tab         = '1'
                ></FormConvenio>

              </Modal>

            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default FechaConvenio;

